import React from 'react';
import {Row, Col} from 'react-bootstrap'
import Sidebar from "../components/Sidebar";
import Navigation from "../components/Navigation";
import Heading from "../components/Heading";
import {useNavigate} from "react-router-dom";
import Footer from "../components/Footer";
import LettersPreviewExportTab from "../components/Letters/LettersPreviewExportTab";
import LettersPreviewManualTab from "../components/Letters/LettersPreviewManualTab";

function LettersPreview(props) {
    const history = useNavigate();
    const pageName = 'letters';
    const MANUAL_TAB = 'ManualLettersTab';
    const EXPORT_TAB = 'ExportLettersTab';
    const [activeTab, setActiveTab] = React.useState(MANUAL_TAB);

    const openLink = () => {
        history('/send-letters-notices')
    }
    return (
        <>
            <Row className="sidebar-background">
                <div className="float-left-child sidebar app-spacing">
                    <Sidebar pageDetails={pageName}/>
                </div>
                <div className="float-right-child app-background app-spacing">
                    <Navigation/>
                    <Heading group="send-letters" title="Letters Preview" result={openLink}/>
                    <Row className="background-1 full-view">
                        <Col lg={{span: 12}} md={{span: 12}}>
                            <div className="card-body-letters-preview mb-5">
                                <ul className="nav nav-tabs mb-4">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === MANUAL_TAB ? 'active letter-active-tab' : ''}`}
                                            onClick={() => setActiveTab(MANUAL_TAB)}
                                        >
                                            Fill In Manually
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${activeTab === EXPORT_TAB ? 'active letter-active-tab' : ''}`}
                                            onClick={() => setActiveTab(EXPORT_TAB)}
                                        >
                                            Import From File
                                        </button>
                                    </li>
                                </ul>

                                {activeTab === MANUAL_TAB &&
                                    <LettersPreviewManualTab/>
                                }

                                {activeTab === EXPORT_TAB &&
                                    <LettersPreviewExportTab/>
                                }
                            </div>

                        </Col>
                        <Footer/>

                    </Row>
                </div>
            </Row>
        </>
    )
        ;
}

export default LettersPreview;
